<template>
  <div>
    <CountingSciFiMap class="traffic-map" />
    <b-row>
      <div>
        <b-row>
          <b-col cols="12">
            <div style="width: 450px;">
              <CountingWayName />
            </div>
          </b-col>
        </b-row>
        <b-col
          cols="12"
          style="margin-top: 415px;"
        >
          <div>
            <CountingSciFiLeftProcess />
          </div>
        </b-col>
      </div>
      <b-row>
        <div class="col-md-12 mt-auto">
          <b-row>
            <b-col cols="12">
              <div>
                <CountingSciFiLeft3line />
              </div>
            </b-col>
          </b-row>
        </div>
      </b-row>
      <!-- </b-row> -->
      <div class="ml-auto">
        <b-col cols="12">
          <CountingSciFiRight />
        </b-col>
      </div>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  // BCard,
} from 'bootstrap-vue'
import CountingWayName from '@/views/countingscifi1/detailfi2/CountingWayName.vue'
import CountingSciFiLeftProcess from '@/views/countingscifi1/CountingSciFiLeftProcess.vue'
import CountingSciFiLeft3line from '@/views/countingscifi1/CountingSciFiLeft3line.vue'

import CountingSciFiRight from '@/views/countingscifi1/CountingSciFiRight.vue'
import CountingSciFiMap from '@/views/countingscifi1/detailfi2/CountingSciFiMap.vue'
// import axios from '@axios'

export default {
  components: {
    CountingWayName,
    CountingSciFiLeftProcess,
    CountingSciFiLeft3line,

    CountingSciFiRight,
    CountingSciFiMap,

    BRow,
    BCol,
    // BCard,
  },
  data() {
    return {
    }
  },
  mounted() {
    this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', true)
  },
  methods: {
  },
}
</script>

  <style>
  .traffic-map {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}
  </style>
